import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <section id="contact" className="py-16 sm:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left Side - Content */}
            <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center">
              <div className="inline-block bg-gray-100 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6 w-fit">
                Get Started Today
              </div>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-6 leading-tight">
                Ready to Ensure Your Property's Safety?
              </h2>
              
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Our EPA-certified professionals are ready to help you with comprehensive environmental consulting services. We respond to most inquiries within one business day.
              </p>

              <div className="space-y-4 mb-10">
                <div className="flex items-center">
                  <div className="flex items-center justify-center w-12 h-12 bg-gray-50 text-[#f59e0b] rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-black">Family Owned</div>
                    <div className="text-sm text-gray-600">30+ years of trusted service</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="flex items-center justify-center w-12 h-12 bg-gray-50 text-[#f59e0b] rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-black">Nationwide Coverage</div>
                    <div className="text-sm text-gray-600">Serving 38+ states across America</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="flex items-center justify-center w-12 h-12 bg-gray-50 text-[#f59e0b] rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-black">Fast Response Time</div>
                    <div className="text-sm text-gray-600">Most inquiries answered within 24 hours</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact#contact-form"
                  className="bg-[#f59e0b] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#d97706] transition-all duration-300 shadow-lg hover:shadow-xl text-center whitespace-nowrap cursor-pointer"
                >
                  Contact Us Now
                </Link>
                <a
                  href="tel:7324189006"
                  className="bg-white text-black px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-50 transition-all duration-300 border-2 border-gray-200 text-center whitespace-nowrap cursor-pointer"
                >
                  Call (732) 418-9006
                </a>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="relative h-64 lg:h-auto min-h-[400px]">
              <img
                src="https://public.readdy.ai/ai/img_res/7d88d5ac23d8e9754df19b0ff762b266.jpg"
                alt="Professional Environmental Inspection"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
